import type { CompareData } from './Compare'

export const VERCEL: CompareData = {
  slug: 'vercel',
  competitor: 'Vercel',
  competitorDomain: 'vercel.com',
  tagline: 'Front-end cloud for Next.js and web application hosting.',
  summary:
    'Vercel hosts web applications. ShimmerTech helps teams design, build, and operate AI systems with FDE teams, governed LLM APIs, evals, and production runbooks.',
  rows: [
    { feature: 'Primary service',     ShimmerTech: 'FDE + LLM infrastructure',     competitor: 'Web app hosting' },
    { feature: 'AI API layer',        ShimmerTech: 'Routing, JSON contracts, evals, logs', competitor: 'Bring your own AI stack' },
    { feature: 'Engineering help',    ShimmerTech: 'Embedded senior builders',     competitor: 'Platform support' },
    { feature: 'GPU / inference',     ShimmerTech: 'Production inference paths',   competitor: 'External provider needed' },
    { feature: 'Best for',            ShimmerTech: 'Production AI workflows',      competitor: 'Next.js / React web apps' },
  ],
  chooseUs: [
    'You need an FDE team to turn an AI workflow into production software.',
    'You need model routing, structured outputs, evals, logs, and cost controls.',
    'You are building an AI product or internal workflow, not only hosting a web frontend.',
  ],
  chooseThem: [
    'You run pure Next.js at enterprise scale and rely on Vercel Edge Middleware / ISR.',
    'You are already committed to Vercel\'s team workflow.',
  ],
  fullMarkdownPath: '/vs/vercel.md',
}

export const RAILWAY: CompareData = {
  slug: 'railway',
  competitor: 'Railway',
  competitorDomain: 'railway.com',
  tagline: 'Developer-friendly application hosting and infrastructure.',
  summary:
    'Railway hosts services and databases. ShimmerTech provides FDE teams and LLM infrastructure for model-powered workflows that need evals, agents, observability, and operating discipline.',
  rows: [
    { feature: 'Primary service',     ShimmerTech: 'FDE + LLM infrastructure',     competitor: 'Service hosting' },
    { feature: 'AI API layer',        ShimmerTech: 'Provider routing, evals, logs', competitor: 'Build it yourself' },
    { feature: 'Implementation help', ShimmerTech: 'Embedded with your team',      competitor: 'Self-service platform' },
    { feature: 'Operations',          ShimmerTech: 'Runbooks and AI release gates', competitor: 'Infra metrics and logs' },
    { feature: 'Best for',            ShimmerTech: 'AI systems in production',     competitor: 'Hosted apps and databases' },
  ],
  chooseUs: [
    'You need help designing and shipping the AI workflow, not only a place to run containers.',
    'You want evals, model routing, prompt contracts, and operational handoff.',
    'You are building internal agents or AI product infrastructure.',
  ],
  chooseThem: [
    'You need fine-grained per-service tuning (CPU/RAM per microservice).',
    'You are already using Railway\'s templates and deploy workflow.',
  ],
  fullMarkdownPath: '/vs/railway.md',
}

export const RENDER: CompareData = {
  slug: 'render',
  competitor: 'Render',
  competitorDomain: 'render.com',
  tagline: 'Managed containers and static sites with per-service pricing.',
  summary:
    'Render hosts web services, workers, and databases. ShimmerTech helps teams build and operate AI systems with FDE delivery, model gateways, evals, GPU inference paths, and runbooks.',
  rows: [
    { feature: 'Primary service',     ShimmerTech: 'FDE + LLM infrastructure',     competitor: 'App hosting' },
    { feature: 'AI workflow design',  ShimmerTech: 'Included in engagement',       competitor: 'Customer-owned' },
    { feature: 'Model operations',    ShimmerTech: 'Evals, logs, retries, routing', competitor: 'Bring your own stack' },
    { feature: 'Inference path',      ShimmerTech: 'GPU and worker design',        competitor: 'Generic services' },
    { feature: 'Best for',            ShimmerTech: 'Production AI workflows',      competitor: 'Hosted web services' },
  ],
  chooseUs: [
    'You need a partner to design and ship the AI system with your team.',
    'You want managed LLM infrastructure rather than assembling every model-operation primitive yourself.',
    'You need production handoff: evals, telemetry, cost controls, and runbooks.',
  ],
  chooseThem: [
    'You need Render\'s specific private networking or autoscaling primitives.',
    'You are already on Render and your infrastructure is tuned around it.',
  ],
  fullMarkdownPath: '/vs/render.md',
}
